export enum PricingFormPageEnum {
    PRICING_PAGE = 'pricing',
    SOLUTIONS_SHOPIFY_PAGE = 'solutions-shopify',
    CONFERENCE_PAGE = 'conference'
}
